<template>
  <div>
    <FiltersTable 
      :getOrderButton="true" 
      titleButton="Obtener órdenes" 
      searchPlaceholder="Buscar por 'Órden ML'"
      @onSearch="onSearch"
      @getOrders="getOrders"/>
    <div>
      <!-- <vs-button vs-button color="primary" type="border" class="mb-3 px-3" :disabled="!canProcessManySelected" @click="processManySelected" >
				<feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3"/>
				Procesar {{canProcessManySelected ? canProcessManySelected : '' }} Seleccionadas
			</vs-button> -->
      <!-- <vs-button vs-button color="primary" type="border" class="mb-3 px-3" disabled >
				<feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3"/>
				Procesar Seleccionadas
			</vs-button> -->
    </div>

    <div v-if="showDetailModal">
        <OrderDetails :orderDetail="orderDetail" @orderDetail="handleOrderDetail" />
    </div>

    <div v-if="showProcessModal || showArchiveModal">
        <PedingProcess :orderProcess="orderProcess" @orderProcess="handleOrderProcess" @closeModal="handleCloseModal"/>
    </div>

    <VxTable 
			stripe
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage">
			
      <template slot="thead">
        <vs-th>Órden ML</vs-th>
        <vs-th>Comprador</vs-th>
        <!-- <vs-th>Destinatario</vs-th>
        <vs-th>DNI facturación</vs-th> -->
        <vs-th style="min-width: 90px">Valor compra</vs-th>
        <vs-th style="min-width: 140px">Fecha</vs-th>
        <vs-th style="min-width: 130px">Actualizada</vs-th>
        <vs-th style="min-width: 80px">Modo</vs-th>
        <vs-th style="min-width: 110px" >Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ data[indextr].id }}
          </vs-td>
          <vs-td>
            Cuenta: <br /><em
              >{{ tr.buyer.first_name }} {{ tr.buyer.last_name }} ({{
                tr.buyer.nickname
              }}).</em
            >
            <br />
            <template
              v-if="tr.shipment_data && tr.shipment_data.receiver_address"
            >
              Recibe: <br />
              <em>{{ tr.shipment_data.receiver_address.receiver_name }} </em>
            </template>
          </vs-td>
          <vs-td> $ {{ tr.total_amount }} </vs-td>
          <vs-td>
            {{ data[indextr].date_created | formatDate }}
          </vs-td>
          <vs-td>
            {{ data[indextr].last_updated | formatDateFromNow }}
          </vs-td>
          <vs-td>
            {{tr.shipment_data.mode | translateShipmentMode }}
          </vs-td>
          <vs-td>
            <!-- <vs-button
              type="border"
              size="small"
              color="primary"
              class="w-full mb-1"
              @click="openPopupDetalle(data[indextr])"
            > -->
              <feather-icon @click="openDetails(tr)" icon="EyeIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Detalle -->
            <!-- </vs-button> -->
            <!-- <vs-button
              type="border"
              size="small"
              color="success"
              class="w-full mb-1"
              @click="openPopupProcesar(data[indextr])"
            > -->
              <feather-icon @click="openProcess(tr)" icon="TruckIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Procesar -->
            <!-- </vs-button> -->
            <!-- <vs-button
              type="border"
              size="small"
              color="danger"
              @click="openPopupArchive(data[indextr])"
              class="w-full mb-1"
            > -->
              <feather-icon @click="openArchive(tr)" icon="FolderIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Desestimar -->
            <!-- </vs-button> -->
          </vs-td>
        </vs-tr>
      </template>
    </VxTable>
  

    <!-- POPUP Desestimar (Archive) -->
    <vs-popup
      class=""
      :title="'Desestimar Órden'"
      :active.sync="popupArchive.open"
      v-if="popupArchive.open"
    >
      <p class="mb-2">
        <strong
          >¿Confirma que desea desestimar la órden #{{
            popupArchive.order.id
          }}?</strong
        >
      </p>
      <p class="mb-4">
        La órden pasará a la seción "Desestimadas" donde no podrá procesarla.
      </p>

      <p class="mb-1 text-right">
        <vs-button
          type="border"
          color="success"
          @click="doArchiveOrder()"
          class="mr-2"
        >
          Si, desestimar esta órden
        </vs-button>
        <vs-button type="border" color="danger" @click="closePopupArchive()">
          Cancelar
        </vs-button>
      </p>
    </vs-popup>

  </div>
</template>

<script>
// Extraer:
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS

// import _ from "lodash"; // ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from "moment";
moment.locale("es");

import axios from "axios";
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import PedingProcess from "../../components/modals/Orders/Pending/PedingProcess.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue"

export default {
  components: {
    OrderDetails,
    PedingProcess,
    FiltersTable
  },
  data() {
    return {
      orders: [],
      ordersPreserved: [], // used when reseting local filtering
      totalItems: 0, // SST
      selected: [], // Los items seleccionados con el checkbox

      // Popup (detalle & proccesar)
      popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
      popupOrderShipmentInfo: null,

      // Popup - detalle
      popupDetalleActive: false,
      // Popup - procesar
      popupProcesarActive: false,

      // Popup - procesar - cotizar
      popupOrderQuotations: {
        available: [],
        fetching: false,
        choosen: null,
        error: null, //
      },

      ancho: null,
      largo: null,
      alto: null,
      peso: null,

      // Popup - procesar - despachar
      isProcessingOrder: false,
      showDimensionsInputs: false,
      processedOrder: false,
      processingErrorMsg: "",
      processingSuccessMsg: "",

      // Popup - desestimar (archive)
      popupArchive: {
        open: false,
        order: {},
      },

      filtersSelected: [],

      processManyShowPopup: false,

      // New data for show modal
      showDetailModal: false,
      orderDetail: {},

      showProcessModal: false,
      showArchiveModal: false,
      orderProcess: {},


    };
  },

  filters: {
    formatDate(rawDate) {
      return moment(rawDate).format("D-M-Y");
    },
    formatDateFromNow(rawDate) {
      return moment(rawDate).fromNow();
    },
    translateShipmentMode(mode) {
      let modesMap = {
        not_specified: "Acuerdo con el vendedor",
        custom: "Envio Custom",
        me1: "Mercado Envíos 1",
        me2: "Mercado Envíos 2",
      };

      return modesMap[mode] ? modesMap[mode] : "";
    },
  },

  mounted() {
    this.loadOrders();
  },

  computed: {
    /**
     * @bool Se deben mostrar las posibles cotizaciones para seleccioanr una?
     */
    popupShowQuotations() {
      return (
        this.popupOrderQuotations.available.length &&
        !this.isProcessingOrder &&
        !this.processedOrder
      );
    },

    qoutationCustomDimensionsEnableContinue() {
      return this.ancho && this.alto && this.largo && this.peso;
    },
  },

  methods: {
    loadOrders(page = 1) {
      this.$vs.loading();

      this.filtersSelected['page'] = page;

      try {
        const filtersSelected = this.filtersSelected;
        const query = Object.keys(filtersSelected)
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
          .join('&');

        axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-pending?' + query)
          .then(orders => {
            console.log(orders.data);

            if (orders.data.body) {
              this.orders = orders.data.body;
              this.ordersPreserved = orders.data.body;
            }
            if (orders.data.paging.total) {
              this.totalItems = orders.data.paging.total;
            }
            if (!orders.data.body) {
              console.log("est Vaccio");
            }
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            this.$vs.loading.close();
          });

      } catch (e) {
        console.log(e);
        this.$vs.loading.close(); 
      }
    },

    handleChangePage(page) {
      this.loadOrders(page);
    },

    getNewOrders(page = 1) {
      axios
        .get(process.env.VUE_APP_BACKEND_URL + "api/getNewOrders")
        .then(() => this.loadOrders(page))
        .catch((error) => {
          console.log(error);
        });
    },

    async doArchiveOrder() {
      this.$vs.loading();
      let order = this.popupArchive.order;
      let url = `${process.env.VUE_APP_BACKEND_URL}api/archive-order/${order.id}/${order.shipping.id}`;
      try {
        let r = await axios.post(url);
        //console.log(r.data);
        this.orders = _.reject(this.orders, { id: order.id });
      } catch (e) {
        console.log(e);
      }
      this.closePopupArchive();
    },

    closePopupArchive() {
      this.$vs.loading.close();

      this.popupArchive.open = false;
      this.popupArchive.order = {};
    },

    randomCenter() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(
        0,
        255
      )},${getRandomInt(0, 255)})`;
      this.$vs.notify({
        title: "Órdenes",
        text: "Órdenes Obtenidas Correctamente",
        color: color,
        position: "top-center",
      });
    },

    // NEW METHODS FOR ACTIONS
    openDetails(tr) {
      this.orderDetail = tr;
      this.showDetailModal = true;
    },
    handleOrderDetail() {
      this.showDetailModal = false;
    },
    openProcess(tr) {
      this.orderProcess = tr;
      this.orderProcess.archive = false;
      this.showProcessModal = true;
    },
    openArchive(tr) {
      this.popupArchive.order = tr;
      this.popupArchive.open = true;
    },
    handleOrderProcess() {
      this.orders = _.reject(this.orders, { id: this.orderProcess.id });
      this.showProcessModal = false;
      this.showArchiveModal = false;
    },
    handleCloseModal() {
      this.showProcessModal = false;
      this.showArchiveModal = false;
    },

    getOrders(){
      this.getNewOrders();
    },

    onSearch(value){
      this.filtersSelected = value;
      this.getNewOrders(1);
    },


    async fetchOrderShipmentInfo(shipmentId) {
      try {
        let shipmentInfo = await axios.get(
          process.env.VUE_APP_BACKEND_URL +
            "api/order-shipment-info/" +
            shipmentId
        );
        if (shipmentInfo.data) {
          //this.popupOrderShipmentInfo = shipmentInfo.data
          return shipmentInfo.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
